<template>
	<div
		class="g-upload-progress"
		:class="[
			`is-variant-${variant}`,
			{ 'is-bar-only': hideFilename && !statusText },
		]"
	>
		<div class="g-upload-progress__item">
			<div class="g-upload-progress__bar">
				<div
					class="g-upload-progress__bar-inner"
					:style="{ width: `${Math.min(100, Math.max(0, displayTask.percent))}%` }"
				></div>
			</div>
			<div v-if="displayTask.filename && !hideFilename" class="g-upload-progress__filename">{{ displayTask.filename }}</div>
			<div v-if="statusText" class="g-upload-progress__status">{{ statusText }}</div>
		</div>
	</div>
</template>

<script>
	import { getMergedUploadDisplay } from '../utils/uploadHeaderMedia.js';

	export default {
		name: 'GUploadProgressPanel',
		props: {
			tasks: {
				type: Array,
				default: () => [],
			},
			filename: {
				type: String,
				default: '',
			},
			percent: {
				type: Number,
				default: 0,
			},
			merge: {
				type: Boolean,
				default: false,
			},
			variant: {
				type: String,
				default: 'modal',
			},
			statusText: {
				type: String,
				default: '上传中...请稍后',
			},
			hideFilename: {
				type: Boolean,
				default: false,
			},
		},
		computed: {
			displayTask() {
				if (this.tasks.length) {
					if (this.merge && this.tasks.length > 1) {
						return getMergedUploadDisplay(this.tasks);
					}
					return this.tasks[0];
				}
				if (this.filename) {
					return { filename: this.filename, percent: this.percent };
				}
				return { filename: '', percent: 0 };
			},
		},
	};
</script>

<style scoped lang="less">
	.g-upload-progress {
		width: 100%;
		box-sizing: border-box;
	}

	.g-upload-progress.is-variant-embedded {
		border: 1px dashed #d9d9d9;
		border-radius: 4px;
		background: #fafafa;
		padding: 40px 32px 36px;
		min-height: 160px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.g-upload-progress.is-variant-modal {
		border: 1px solid #eee;
		border-radius: 4px;
		background: #fff;
		padding: 32px 28px 28px;
		min-height: 140px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.g-upload-progress.is-variant-item {
		height: 100%;
		padding: 10px 6px;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		justify-content: center;
		background: #fafafa;
	}

	.g-upload-progress.is-variant-item .g-upload-progress__item {
		max-width: none;
	}

	.g-upload-progress.is-variant-item .g-upload-progress__filename {
		margin-top: 8px;
		font-size: 10px;
	}

	.g-upload-progress.is-variant-item .g-upload-progress__status {
		margin-top: 6px;
		font-size: 10px;
	}

	.g-upload-progress.is-variant-item.is-bar-only {
		padding: 0 6px;
	}

	.g-upload-progress.is-variant-row {
		flex: 1;
		min-width: 0;
		padding: 0 8px;
	}

	.g-upload-progress.is-variant-row .g-upload-progress__item {
		max-width: none;
	}

	.g-upload-progress.is-variant-row .g-upload-progress__filename {
		margin-top: 10px;
		font-size: 12px;
	}

	.g-upload-progress.is-variant-row .g-upload-progress__status {
		margin-top: 6px;
		font-size: 12px;
	}

	.g-upload-progress__item {
		width: 100%;
		max-width: 420px;
		text-align: center;
	}

	.g-upload-progress.is-variant-embedded .g-upload-progress__item {
		max-width: 360px;
	}

	.g-upload-progress__bar {
		height: 6px;
		border-radius: 999px;
		background: #dfe8f5;
		overflow: hidden;
	}

	.g-upload-progress__bar-inner {
		height: 100%;
		border-radius: inherit;
		background: #285af9;
		transition: width 0.2s ease;
	}

	.g-upload-progress__filename {
		margin-top: 16px;
		font-size: 13px;
		color: #333;
		line-height: 1.4;
		text-align: center;
		word-break: break-all;
	}

	.g-upload-progress__status {
		margin-top: 8px;
		font-size: 12px;
		color: #999;
		line-height: 1.4;
		text-align: center;
	}
</style>
